export const AG_GRID_LOCALE_IT = {
  // Set Filter
  selectAll: '(Seleziona tutto)',
  selectAllSearchResults: '(Seleziona tutti i risultati)',
  searchOoo: 'Cerca...',
  blanks: '(Cancella)',
  noMatches: 'Nessun dato',

  // Number Filter & Text Filter
  filterOoo: 'Filtra...',
  equals: 'Uguale',
  notEqual: 'Non uguale',
  empty: 'Scegli uno',

  // Number Filter
  lessThan: 'Minore',
  greaterThan: 'Maggiore',
  lessThanOrEqual: 'Minore o uguale',
  greaterThanOrEqual: 'Maggiore o uguale',
  inRange: 'Intervallo',
  inRangeStart: 'Da',
  inRangeEnd: 'A',

  // Text Filter
  contains: 'Contiene',
  notContains: 'Non contiene',
  startsWith: 'Inizia con',
  endsWith: 'Termina con',
  chapter: 'Capitolo',

  // Date Filter
  dateFormatOoo: 'dd-mm-yyyy',

  // Filter Conditions
  andCondition: 'AND',
  orCondition: 'OR',

  // Filter Buttons
  applyFilter: 'Applica',
  resetFilter: 'Ripristina',
  clearFilter: 'Svuota',
  cancelFilter: 'Cancella',

  // Filter Titles
  textFilter: 'Filtro testo',
  numberFilter: 'Filtro numero',
  dateFilter: 'Filtro data',
  setFilter: 'Seleziona filtro',

  // Side Bar
  columns: 'Colonne',
  filters: 'Filtri',

  // columns tool panel
  pivotMode: 'Pivot Mode',
  groups: 'Gruppi',
  rowGroupColumnsEmptyMessage: 'Trascina qui per selezionare i gruppi',
  values: 'Valori',
  valueColumnsEmptyMessage: 'Trascina qui per aggregare',
  pivots: 'Colonne',
  pivotColumnsEmptyMessage: 'Trascina qui per selezionare le colonne',

  // Header of the Default Group Column
  group: 'Gruppi',

  // Other
  loadingOoo: 'Caricamento...',
  noRowsToShow: 'Nessuna riga da mostrare',
  enabled: 'Abilitato',

  // Menu
  pinColumn: 'Fissa colonna',
  pinLeft: 'Fissa a sinistra',
  pinRight: 'Fissa a destra',
  noPin: 'Non fissare',
  valueAggregation: 'Valore aggregato',
  autosizeThiscolumn: 'Larghezza automatica colonna',
  autosizeAllColumns: 'Larghezza automatica colonne',
  groupBy: 'Raggruppa per',
  ungroupBy: 'Rimuovi raggruppa',
  resetColumns: 'Ripristina colonne',
  expandAll: 'Espandi tutto',
  collapseAll: 'Chiudo tutto',
  copy: 'Copia',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Copia con intestazione',
  paste: 'Incolla',
  ctrlV: 'Ctrl+V',
  export: 'Esporta',
  csvExport: 'Esporta CSV',
  excelExport: 'Esporta Excel',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Somma',
  min: 'Minimo',
  max: 'Massimo',
  none: 'Nessuno',
  count: 'Conteggio',
  avg: 'Media',
  filteredRows: 'Filtrati',
  selectedRows: 'Selezionati',
  totalRows: 'Righe totali',
  totalAndFilteredRows: 'Righe',
  more: 'Altro',
  to: 'a',
  of: 'di',
  page: 'Pagina',
  nextPage: 'Pagina successiva',
  lastPage: 'Ultima pagina',
  firstPage: 'Prima pagina',
  previousPage: 'Pagina precedente',

  // Pivoting
  pivotColumnGroupTotals: 'Totale',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  columnChart: 'Column',
  groupedColumn: 'Grouped',
  stackedColumn: 'Stacked',
  normalizedColumn: '100% Stacked',

  barChart: 'Bar',
  groupedBar: 'Grouped',
  stackedBar: 'Stacked',
  normalizedBar: '100% Stacked',

  pieChart: 'Pie',
  pie: 'Pie',
  doughnut: 'Doughnut',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Area',
  area: 'Area',
  stackedArea: 'Stacked',
  normalizedArea: '100% Stacked',

  histogramChart: 'Histogram',

  // Charts
  pivotChartTitle: 'Pivot Chart',
  rangeChartTitle: 'Range Chart',
  settings: 'Settings',
  data: 'Data',
  format: 'Format',
  categories: 'Categories',
  defaultCategory: '(None)',
  series: 'Series',
  xyValues: 'X Y Values',
  paired: 'Paired Mode',
  axis: 'Axis',
  navigator: 'Navigator',
  color: 'Color',
  thickness: 'Thickness',
  xType: 'X Type',
  automatic: 'Automatic',
  category: 'Category',
  number: 'Number',
  time: 'Time',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Ticks',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  padding: 'Padding',
  spacing: 'Spacing',
  chart: 'Chart',
  title: 'Title',
  titlePlaceholder: 'Chart title - double click to edit',
  background: 'Background',
  font: 'Font',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  labels: 'Labels',
  size: 'Size',
  minSize: 'Minimum Size',
  maxSize: 'Maximum Size',
  legend: 'Legend',
  position: 'Position',
  markerSize: 'Marker Size',
  markerStroke: 'Marker Stroke',
  markerPadding: 'Marker Padding',
  itemSpacing: 'Item Spacing',
  itemPaddingX: 'Item Padding X',
  itemPaddingY: 'Item Padding Y',
  layoutHorizontalSpacing: 'Horizontal Spacing',
  layoutVerticalSpacing: 'Vertical Spacing',
  strokeWidth: 'Stroke Width',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markers',
  shadow: 'Shadow',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Line Width',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Bin count',
  columnGroup: 'Column',
  barGroup: 'Bar',
  pieGroup: 'Pie',
  lineGroup: 'Line',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Area',
  histogramGroup: 'Histogram',
  groupedColumnTooltip: 'Grouped',
  stackedColumnTooltip: 'Stacked',
  normalizedColumnTooltip: '100% Stacked',
  groupedBarTooltip: 'Grouped',
  stackedBarTooltip: 'Stacked',
  normalizedBarTooltip: '100% Stacked',
  pieTooltip: 'Pie',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Line',
  groupedAreaTooltip: 'Area',
  stackedAreaTooltip: 'Stacked',
  normalizedAreaTooltip: '100% Stacked',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  noDataToChart: 'No data available to be charted.',
  pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Linked to Grid',
  chartUnlinkToolbarTooltip: 'Unlinked from Grid',
  chartDownloadToolbarTooltip: 'Download Chart',

  // ARIA
  ariaHidden: 'hidden',
  ariaVisible: 'visible',
  ariaChecked: 'checked',
  ariaUnchecked: 'unchecked',
  ariaIndeterminate: 'indeterminate',
  ariaColumnSelectAll: 'Toggle Select All Columns',
  ariaInputEditor: 'Input Editor',
  ariaDateFilterInput: 'Date Filter Input',
  ariaFilterInput: 'Filter Input',
  ariaFilterColumnsInput: 'Filter Columns Input',
  ariaFilterValue: 'Filter Value',
  ariaFilterFromValue: 'Filter from value',
  ariaFilterToValue: 'Filter to value',
  ariaFilteringOperator: 'Filtering Operator',
  ariaColumnToggleVisibility: 'column toggle visibility',
  ariaColumnGroupToggleVisibility: 'column group toggle visibility',
  ariaRowSelect: 'Press SPACE to select this row',
  ariaRowDeselect: 'Press SPACE to deselect this row',
  ariaRowToggleSelection: 'Press Space to toggle row selection',
  ariaRowSelectAll: 'Press Space to toggle all rows selection',
  ariaSearch: 'Search',
  ariaSearchFilterValues: 'Search filter values',

  /*ContextMenuItems*/
  download: 'Scarica',
  delete: 'Elimina',
  edit: 'Modifica',
  move: 'Sposta',
  open: 'Apri',
  showDetail: 'Dettagli',
  rename: 'Rinomina',
  greaterThanEmpty: 'Maggiore',
  lessThanEmpty: 'Minore',

  /*CustomsFields*/
  details: 'Dettagli',
  dataSource: 'Storage',
  username: 'Username',
  email: 'Email',
  name: 'Nome',
  surname: 'Cognome',
  banned: 'Bloccato',
  lastLoggedAt: 'Ultimo accesso',
  createdAt: 'Data creazione',
  domain: 'Dominio',
  uuid: 'UUID',
  dedicatedSchema: 'Schema dedicato',
  status: 'Stato',
  createAt: 'Data creazione',
  resourceName: 'Nome',
  operationType: 'Operazione',
  date: 'Data',
  changes: 'Modifiche',
  type: 'Tipologia',
  openParent: 'Apri cartella padre',
  note: 'Nota',

  entityType: 'Nome entità',
  userInfo: 'Info utente',
  builtIn: 'Di sistema',
  entityId: 'Id Entità',
  userId: 'Id Utente',
  user: 'Utente',
  startedAt: 'Avviato il',
  completedAt: 'Completato il',
  applications: 'Applicazioni',
  vulnerabilities: 'Vulnerabilità',
  orgName: 'Nome Organizzazione',
};
